// store/index.js
// Vue2 + Vuex3 写法

import Vue from 'vue'
import Vuex from 'vuex'

// 必须先调用此方法，Vuex 才能注入 $store
Vue.use(Vuex)

// 引入模块化文件
import user from "./modules/user";
import site from "./modules/site";
import music from "./modules/music";

// 自定义简单持久化插件（无需额外依赖）
const STORAGE_KEY = 'vuex-state'

const simplePersist = (store) => {
  // 1. 启动时从 localStorage 读取，使用 replaceState 合并到根 state
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved) {
      const parsed = JSON.parse(saved)
      const current = JSON.parse(JSON.stringify(store.state))
      // 合并：user/site 全量覆盖；music 仅恢复偏好相关字段
      if (parsed.user) current.user = Object.assign({}, current.user, parsed.user)
      if (parsed.site) current.site = Object.assign({}, current.site, parsed.site)
      if (parsed.music) {
        current.music = Object.assign({}, current.music, {
          currentSong: parsed.music.currentSong || current.music.currentSong,
          musicList: parsed.music.musicList || current.music.musicList,
          currentIndex: parsed.music.currentIndex !== undefined ? parsed.music.currentIndex : current.music.currentIndex,
          playMode: parsed.music.playMode !== undefined ? parsed.music.playMode : current.music.playMode,
          volume: parsed.music.volume !== undefined ? parsed.music.volume : current.music.volume,
          showFloatingPlayer: parsed.music.showFloatingPlayer !== undefined ? parsed.music.showFloatingPlayer : current.music.showFloatingPlayer,
          playerPosition: parsed.music.playerPosition || current.music.playerPosition
        })
      }
      store.replaceState(current)
    }
  } catch (e) {
    // 静默忽略
  }

  // 2. 订阅每次 mutation，保存需要持久化的字段
  store.subscribe((_, state) => {
    try {
      const toSave = {
        user: state.user,
        site: state.site,
        music: {
          currentSong: state.music.currentSong,
          musicList: state.music.musicList,
          currentIndex: state.music.currentIndex,
          playMode: state.music.playMode,
          volume: state.music.volume,
          showFloatingPlayer: state.music.showFloatingPlayer,
          playerPosition: state.music.playerPosition
        }
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave))
    } catch (e) {
      // 静默忽略
    }
  })
}

const store = new Vuex.Store({
  modules: {
    user,
    site,
    music
  },
  plugins: [simplePersist]
});

export default store;